import { render, staticRenderFns } from "./Homepage.vue?vue&type=template&id=bfe1a5b6&scoped=true"
import script from "./Homepage.vue?vue&type=script&lang=ts"
export * from "./Homepage.vue?vue&type=script&lang=ts"
import style0 from "./Homepage.vue?vue&type=style&index=0&id=bfe1a5b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe1a5b6",
  null
  
)

export default component.exports